<template>
  <div class="column content-box full_page">
    <section>
         <woot-button
            color-scheme="success"
            class-names="button--fixed-right-top"
            icon="arrow-download"
            @click="downloadMeetingReport"
        >
        {{$t('CALENDAR_MGMT.REPORTS.MEETING.DOWNLOAD_BTN')}}
        </woot-button>
    </section>
    <section>
      <MultiselectDropdown
            :label="$t('CALENDAR_MGMT.REPORTS.TOOLS.DATE_RANGE.LABEL')"
        >
            <date-range-picker
                :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
                :placeholder="$t('CALENDAR_MGMT.REPORTS.TOOLS.DATE_RANGE.PLACEHOLDER')"
                :value="dateRange"
                :displayFormat="'D MMM YYYY'"
                @change="handleDateChange"
                :disabledDate="disableFilterDate"
            />
        </MultiselectDropdown>
    </section>

    <section>
        <AppointmentReport />
    </section>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue"
import DateRangePicker from "../../../../../dashboard/components/ui/DateRangePicker.vue"
import alertMixin from 'shared/mixins/alertMixin';
import helperMixin from 'shared/mixins/helperMixin';
import AppointmentReport from './AppointmentReport.vue';

export default {
  components: {
    MultiselectDropdown,
    DateRangePicker,
    AppointmentReport,
  },
  mixins:[helperMixin,alertMixin],
  data() {
     const endDate = new Date(); // Current date
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 1); // One month ago

    return {
        dateRange: [startDate,endDate],
        dates:{
            start_date: null,
            end_date: null,
        }
    };
  },
  computed:{
    ...mapGetters({
      meetingReports: "meetings/getMeetingReports",
    }),
  },
  mounted(){
    this.handleDateChange(this.dateRange)
  },
  methods: {
    fetchMeetings(query){
        let prepareQuery = {
            start_date : query.start_date ?? this.dateRange[0],
            end_date : query.end_date ?? this.dateRange[1],
            // user_id: query.user_id ?? this.selectedUser?.id,
        }
        if (!prepareQuery.start_date) {
            return
        }
        const {start_date,end_date} = this.formatStartEndDate(prepareQuery.start_date,prepareQuery.end_date);

        prepareQuery = {
            ...prepareQuery,
            start_date: start_date.split('T')[0],
            end_date: end_date.split('T')[0],
        }
        this.$store.dispatch('meetings/getMeetingReports',this.cleanObject(prepareQuery));
    },
    handleDateChange(dateRange) {
      this.dateRange = dateRange;
      const date = this.formatStartEndDate(dateRange[0],dateRange[1]);
      this.fetchMeetings(date)
    },
    disableFilterDate(date,currentValues){
        return false;
    },
    downloadMeetingReport() {
        const report = this.meetingReports || {};
        const weekDays = Object.keys(report);

        // Collect all unique keys across all weekdays
        const uniqueKeys = new Set();
        weekDays.forEach(day => {
            const entries = report[day] || {};
            Object.keys(entries).forEach(key => uniqueKeys.add(key));
        });

        const keyList = Array.from(uniqueKeys);
        const headers = ['Day', ...keyList];

        // Build rows dynamically
        const rows = weekDays.map(day => {
            const row = [day.charAt(0).toUpperCase() + day.slice(1)];
            const data = report[day] || {};
            keyList.forEach(key => {
            row.push(data[key] ?? 0);
            });
            return row;
        });
        this.downloadCSVFile('meeting_report.csv', headers, rows);
        // const csvContent = [headers, ...rows]
        //     .map(e => e.join(','))
        //     .join('\n');

        // const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        // const url = URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.setAttribute("href", url);
        // link.setAttribute("download", "meeting_report.csv");
        // link.click();
    },
    // end methods
  },
};
</script>

<style>

</style>